import script from "./BrandChannelHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandChannelHeader.vue?vue&type=script&setup=true&lang=js"

import "./BrandChannelHeader.vue?vue&type=style&index=0&id=24043172&lang=css"

const __exports__ = script;

export default __exports__